import React, { type ReactNode } from './react';

export class QueryClient {
  constructor(_options?: unknown) {}
}

export function QueryClientProvider({ children }: { client: QueryClient; children?: ReactNode[] | ReactNode }) {
  return <>{children}</>;
}
